import { Remote, remoteEnum } from '@/data/source/remote/remoteApi'

const fetchUserInfo = () => new Remote(remoteEnum.get, 'userinfo')

export {
  fetchUserInfo
}
